export const CRTeamraiserAPI = 'CRTeamraiserAPI';
export const CRConsAPI = 'CRConsAPI';
export const CRContentAPI = 'CRContentAPI';
export const CRSurveyAPI = 'CRSurveyAPI';
export const CRDonationAPI = 'CRDonationAPI';
